import { ElementType } from 'react';

import {
  AutocompleteProps,
  default as MuiAutocomplete,
} from '@mui/material/Autocomplete';
import { ChipTypeMap } from '@mui/material/Chip';

const Autocomplete = <
  T,
  Multiple extends boolean | undefined,
  DisableClearable extends boolean | undefined,
  FreeSolo extends boolean | undefined,
  ChipComponent extends ElementType = ChipTypeMap['defaultComponent']
>({
  value,
  onBlur,
  onChange,
  inputValue,
  onInputChange,
  getOptionLabel,
  id,
  options,
  sx,
  renderInput,
  property,
  className,
  multiple,
  filterSelectedOptions,
  isOptionEqualToValue,
  disabled,
  classes,
  renderTags,
  renderOption,
  clearOnBlur,
}: AutocompleteProps<
  T,
  Multiple,
  DisableClearable,
  FreeSolo,
  ChipComponent
>): JSX.Element => {
  return (
    <MuiAutocomplete
      value={value}
      classes={classes}
      onBlur={onBlur}
      onChange={onChange}
      inputValue={inputValue}
      onInputChange={onInputChange}
      getOptionLabel={getOptionLabel}
      id={id}
      options={options}
      sx={sx}
      renderInput={renderInput}
      renderTags={renderTags}
      renderOption={renderOption}
      property={property}
      className={className}
      multiple={multiple}
      filterSelectedOptions={filterSelectedOptions}
      isOptionEqualToValue={isOptionEqualToValue}
      disabled={disabled}
      clearOnBlur={clearOnBlur}
    ></MuiAutocomplete>
  );
};

export default Autocomplete;
